import React, { useEffect, useState } from 'react';
import DisplayNoteModal from './DisplayNoteModal';

interface NoteIconProps {
    noteText: string;
    noteId: number;
    bookId: string;
    handleDelete: () => void;
}

const NoteIcon: React.FC<NoteIconProps> = ({
    noteText,
    noteId,
    bookId,
    handleDelete,
}) => {
    useEffect(() => {
        const handleNoteIconClick = (event: MessageEvent) => {
            if (event.data.type == 'notes') {
                setIsModalOpen(true);
            }
        };
        window.addEventListener('message', handleNoteIconClick);
        return () => {
            window.removeEventListener('message', handleNoteIconClick);
        };
    });
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    return (
        <>
            {isModalOpen && (
                <DisplayNoteModal
                    onClose={toggleModal}
                    noteId={noteId}
                    initialNote={noteText}
                    bookId={bookId}
                    handleDelete={handleDelete}
                />
            )}
        </>
    );
};

export default NoteIcon;
